import Application from './application';

let Preloader = function (params) {
  // console.log('Preloader initalizing ' + Application.tweenLength);

  /**
   * PRELOAD STUFF
   */
  let preloadTotal = 0;
  let preloadCount = 0;
  let extension = ".png";
  let images = [];
  let self = this;
  let preloaderElement = document.getElementById( 'preloader' );
  let loaderFill = preloaderElement.querySelector('.preloader-fill');
  let loaderBar = preloaderElement.querySelector('.preloader-bar');
  let loadingText = preloaderElement.querySelector( '.preloader-label' );
  let overlay = preloaderElement.querySelector( '.preloader-overlay' );
  let timeline;
  // Wait for modernizr to determine webp support before we start the loading sequence
  Modernizr.on('webp', function(result) {
    // console.log('webp support = ' + result);
    if ( result ) {
      extension = ".webp";
    }
    // temp beta hack
    // extension = ".png";
    console.log('extension is ' + extension);
    self.images = [
      'common/arrow-right' + extension,
      'common/arrow-left' + extension,
      'common/slider.png',
      'common/slider-bar.png',
      'intro/bg.jpg',
      'question-1/bg.jpg',
      'question-3/bg.jpg',
      'question-4/bg.jpg',
      'question-5/bg.jpg',
      'question-6/bg.jpg',
      'results/bg.jpg',
      'intro/content' + extension,
      'question-2/content' + extension,
      'question-3/content' + extension,
      'question-4/slider-1' + extension,
      'question-4/slider-2' + extension,
      'question-4/slider-3' + extension,
      'question-5/slider-1' + extension,
      'question-5/slider-2' + extension,
      'question-5/slider-3' + extension,
      'question-6/slider-1' + extension,
      'question-6/slider-2' + extension,
      'question-6/slider-3' + extension,
      'results/club-t100' + extension,
      'results/club-t200' + extension,
      'results/club-t300' + extension,
      'results/club-620cb' + extension,
      'results/club-620mb' + extension,
      'results/logo-t100' + extension,
      'results/logo-t200' + extension,
      'results/logo-t300' + extension,
      'results/logo-620cb' + extension,
      'results/logo-620mb' + extension
    ];
    startLoading();
  });

  function startLoading() {
    console.log('startLoading ', self.images);
    let imageFile;
    let imageTag;
    for (let i = 0; i < self.images.length; i++) {
      imageFile = self.images[i];
      imageTag = new Image();
      imageTag.src = '../assets/images/' + imageFile;
      imageTag.addEventListener('load', fileLoaded);
      imageTag.addEventListener('error', fileError);
    }
  }

  let percent = 0;
  let loaderTween;
  function fileLoaded() {
    console.log('image loaded');
    preloadCount++;
    //update loader bar
    percent = Math.round((preloadCount / preloadTotal) * 100);
    if ( percent > 100 ) {
      percent = 100;
    }
    if ( loaderTween !== undefined ) {
      loaderTween.kill();
    }
    loaderTween = TweenLite.to(loaderFill, 1, {width: percent.toString() + '%', onComplete: checkPreloadCount});
  }

  function fileError() {
    console.log("");
    console.log("ERROR loading file, proceeding with app experience anyway...");
    console.log("");
    // comment the rest of this function out to stop the app when an image doesn't load,
    // but the app should still be usable without most image files, so we will let it proceed...
    preloadCount++;
    //update loader bar
    percent = Math.round((preloadCount / preloadTotal) * 100);
    if ( percent > 100 ) {
      percent = 100;
    }
    if ( loaderTween !== undefined ) {
      loaderTween.kill();
    }
    loaderTween = TweenLite.to(loaderFill, 1, {width: percent.toString() + '%', onComplete: checkPreloadCount});
  }

  function checkPreloadCount() {
    //check for all images
    if (preloadCount >= preloadTotal) {
      // console.log('everything is loaded');
      // showIntro();
      closePreloader();
    }
  }

  function closePreloader() {
    timeline = new TimelineLite({onComplete: closeComplete});
    timeline.to([loaderBar, loadingText], Application.tweenLength, {opacity: 0});
    timeline.to(overlay, Application.tweenLength, {opacity: 0}, "-=" + Application.tweenStagger.toString());
    // loaderTween = TweenLite.to([loaderBar, loadingText], Application.tweenLength, {opacity: 0});
    // loaderTween2 = TweenLite.to(overlay, Application.tweenLength, {opacity: 0, delay: Application.tweenStagger, onComplete: closeComplete});
  }

  function closeComplete() {
    loaderTween.kill();
    loaderTween = null;
    timeline.kill();
    timeline = null;
    preloaderElement.style.display = 'none';
    // window.intro.open();
    window.ironSelector.preloaderClosed();
  }
};

export default Preloader;

